import { useEffect, useState } from "react";
import styles from "../../../styles/search.module.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
const Search = () => {
  const[searchquery,setsearchquery]=useState("");
  const [isActive, setisactive] = useState(false);
  const navigate=useNavigate();
  const location=useLocation();
  function displaysearch() {
    setisactive(!isActive);
  }

  function handlesearch(e){
    e.preventDefault();
    if(searchquery.trim()){
    navigate(`/blogs?search=${encodeURIComponent(searchquery)}`);
    
    }else{
      navigate(`/blogs`);
    }
  }

  useEffect(() => {
    if (isActive === true) {
      document.documentElement.style.overflowY = "hidden";
    } else {
      document.documentElement.style.overflowY = "scroll";
    }

    console.log(isActive);
  }, [isActive]);

  useEffect(() => {
    setisactive(false)
  }, [location]);

  return (
    <div className={styles.searchwrapper}>
      <svg
        onClick={(e) => displaysearch(e)}
        width="30"
        height="30"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="icon icon-tabler icons-tabler-outline icon-tabler-search"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
        <path d="M21 21l-6 -6" />
      </svg>
               <form onSubmit={(e)=>{handlesearch(e);displaysearch();}}>
      <div
        id="search"
        className={`${isActive ? styles.searchtextwrapper : styles.searchoff2}`}
      >

        <div onClick={displaysearch} className={styles.hidesearch}></div>
 
        <input
          type="text"
          placeholder="Search..."
          className={styles.searchinput}
          value={searchquery}
          onChange={(e)=>setsearchquery(e.target.value)}
        />
        <button type="submit" className={styles.searchbutton}>
          <svg
            width="30"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-search"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
            <path d="M21 21l-6 -6" />
          </svg>
        </button>

      </div>
               </form>
    </div>
  );
};

export default Search;
